import React from 'react'
import PropTypes from 'prop-types'
import css from './messages-box.css'

const MessagesBox = ({
  totalReminders,
  numAppt,
  numApptConfirmed,
  numTextRemindersSent,
  numTextRemindersDelivered,
  numEmailRemindersSent,
  numEmailRemindersDelivered,
}) => (
  <div className={css.container}>
    <div className={css.headsUp}>
      <p>Total Reminders</p>
      <p>{totalReminders}</p>
    </div>
    <div className={css.table}>
      <div className={css.row}>
        <span className={css.cell}>Appointments</span>
        <span className={css.cell}>{numAppt}</span>
      </div>
      <div className={css.row}>
        <span className={css.cell}>Appointments Confirmed</span>
        <span className={css.cell}>{numApptConfirmed}</span>
      </div>
      <div className={css.row}>
        <span className={css.cell}>Text Reminders Sent</span>
        <span className={css.cell}>{numTextRemindersSent}</span>
      </div>
      <div className={css.row}>
        <span className={css.cell}>Text Reminders Delivered</span>
        <span className={css.cell}>{numTextRemindersDelivered}</span>
      </div>
      <div className={css.row}>
        <span className={css.cell}>Email Reminders Sent</span>
        <span className={css.cell}>{numEmailRemindersSent}</span>
      </div>
      <div className={css.row}>
        <span className={css.cell}>Email Reminders Delivered</span>
        <span className={css.cell}>{numEmailRemindersDelivered}</span>
      </div>
    </div>
  </div>
)

MessagesBox.propTypes = {
  numAppt: PropTypes.number.isRequired,
  numApptConfirmed: PropTypes.number.isRequired,
  numTextRemindersSent: PropTypes.number.isRequired,
  numEmailRemindersSent: PropTypes.number.isRequired,
  numTextRemindersDelivered: PropTypes.number.isRequired,
  numEmailRemindersDelivered: PropTypes.number.isRequired,
  totalReminders: PropTypes.number.isRequired,
}

export default MessagesBox



// WEBPACK FOOTER //
// ./src/components/Dashboard/MessagesBox.js